import { Rectangle } from "../../maths/Rectangle";
import { ClassUtils } from "../../utils/ClassUtils";
import { Pool } from "../../utils/Pool";
const className = "DrawRoundRectCmd";
export class DrawRoundRectCmd {
    constructor() {
        this.x = 0;
        this.y = 0;
        this.width = 1;
        this.height = 1;
        this.lt = 6;
        this.rt = 6;
        this.lb = 6;
        this.rb = 6;
        this.lineWidth = 0;
        this.percent = true;
        this.minNum = 20;
        this.segPixel = 5;
    }
    static create(x, y, width, height, lt, rt, lb, rb, fillColor, lineColor, lineWidth, percent, minNum, segPixel) {
        var cmd = Pool.getItemByClass(className, DrawRoundRectCmd);
        cmd.x = x;
        cmd.y = y;
        cmd.width = width;
        cmd.height = height;
        cmd.lt = lt;
        cmd.rt = rt;
        cmd.lb = lb;
        cmd.rb = rb;
        cmd.fillColor = fillColor;
        cmd.lineColor = lineColor;
        cmd.lineWidth = lineWidth;
        cmd.percent = percent;
        if (minNum != null)
            cmd.minNum = minNum;
        if (segPixel != null)
            cmd.segPixel = segPixel;
        return cmd;
    }
    recover() {
        this.fillColor = null;
        this.lineColor = null;
        this.minNum = 20;
        this.segPixel = 5;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        let offset = (this.lineWidth >= 1 && this.lineColor) ? this.lineWidth / 2 : 0;
        let lineOffset = this.lineColor ? this.lineWidth : 0;
        if (this.percent && runner.sprite) {
            let w = runner.sprite.width;
            let h = runner.sprite.height;
            runner._drawRoundRect(this.x * w + offset + gx, this.y * h + offset + gy, this.width * w - lineOffset, this.height * h - lineOffset, this.lt, this.rt, this.lb, this.rb, this.fillColor, this.lineColor, this.lineWidth, this.minNum, this.segPixel);
        }
        else {
            runner._drawRoundRect(this.x + offset + gx, this.y + offset + gy, this.width - lineOffset, this.height - lineOffset, this.lt, this.rt, this.lb, this.rb, this.fillColor, this.lineColor, this.lineWidth, this.minNum, this.segPixel);
        }
    }
    get cmdID() {
        return DrawRoundRectCmd.ID;
    }
    needsLayoutRepaint() {
        return 1;
    }
    getBounds(assembler) {
        let rect = Rectangle.TEMP.setTo(this.x, this.y, this.width, this.height);
        if (this.percent) {
            rect.scale(assembler.width, assembler.height);
        }
        rect.getBoundPoints(assembler.points);
    }
}
DrawRoundRectCmd.ID = className;
ClassUtils.regClass(className, DrawRoundRectCmd);
